import { Error403, SEO } from 'components/common'

export const Head = () => <SEO title={'Forbidden'} />

const ForbiddenPage = (): JSX.Element => {
  return (
    <>
      <Error403 />
    </>
  )
}

export default ForbiddenPage
